"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const arrowupforward = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-arrowupforward` : '') + (description ? ` desc-arrowupforward` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-arrowupforward"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-arrowupforward"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_19209_7835)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m4.62 4.7.03.13c.12.4.49.7.91.7l11.46.1L4.04 18.62l-.08.08a.95.95 0 0 0 .09 1.25l.08.08c.37.3.9.27 1.25-.07L18.37 6.97l.1 11.47.01.12c.08.48.47.82.94.83.52 0 .94-.42.94-.94L20.24 4.7l-.01-.1-.03-.14-.03-.1-.06-.12-.03-.06-.07-.08-.05-.06a.98.98 0 0 0-.23-.17l-.1-.05-.13-.04a.96.96 0 0 0-.21-.03L5.55 3.64h-.14a.93.93 0 0 0-.8.94l.01.12Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_19209_7835"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = arrowupforward;